var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('div',_vm._l((_vm.items),function(item,index){return _c('h6',{key:'bread'+index},[_vm._v(" "+_vm._s(item)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }